import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section aria-labelledby="bonus-title" className="border-y-2 border-ink bg-cream" data-id="element-13" data-mp="pjzlbb82zkbs">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-24" data-id="element-14" data-mp="plsje24mow86">
        <div className="max-w-2xl" data-id="element-15" data-mp="aujzm9neq52y">
          <p className="font-display text-lg font-medium italic text-kraft-dark" data-id="element-16" data-mp="at8t422kuj85">Y además del diario te llevas</p>
          <h2 id="bonus-title" className="mt-2 font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-17" data-mp="1un5hsi90e0i">
            5 bonos de acción rápida
          </h2>
        </div>

        <ul className="mt-10 grid gap-x-6 gap-y-8 sm:mt-12 sm:gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="3o1lg6tx6hpki">
          {bonuses.map(b => <li key={b.number} className="relative flex flex-col rounded-2xl border-2 border-ink bg-paper px-5 pb-5 pt-9 sm:px-6 sm:pb-6 sm:pt-10" data-id="element-19" data-mp="3t06hyxs2whb2">
              <span className="absolute -top-5 left-6 flex h-10 min-w-[3.5rem] items-center justify-center rounded-b-2xl rounded-t-md bg-ink px-3 font-display text-lg font-black text-cream" data-id="element-20" data-mp="1mb1nvmgup1ei">
                #{b.number}
              </span>
              <p className="font-display text-xs font-bold uppercase tracking-wider text-kraft-dark" data-id="element-21" data-mp="3dfv7b4fdbnce">Bono {b.number}</p>
              <h3 className="mt-1 font-display text-xl font-extrabold leading-snug" data-id="element-22" data-mp="3r5ovdkj1u3l2">{b.title}</h3>
              <p className="mt-3 flex-1 leading-relaxed text-ink-soft" data-id="element-23" data-mp="3n67p4ovst2eu">{b.text}</p>
              <div className="mt-6 flex items-center justify-between border-t border-dashed border-kraft-dark/50 pt-4" data-id="element-24" data-mp="2zf2bmgdbym7p">
                <span className="text-sm text-ink-soft" data-id="element-25" data-mp="2uhiw7d4wc3e6">
                  Valor <s className="font-bold" data-id="element-26" data-mp="38g0gt1zi8zrv">{b.value}</s>
                </span>
                <span className="rounded-full bg-rust px-3 py-1 font-display text-sm font-extrabold" data-id="element-27" data-mp="38dw2dq3zcidc">Hoy gratis</span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}